import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "visit-win-bar"
};
const _hoisted_2 = {
  key: 0,
  class: "vxe-icon-indicator roll"
};
import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from 'vue';
import { MgDropMenu, MgPopMenu } from '@/components/mgui';
import { useRouter, useRoute } from 'vue-router';
import { createUseHistoryStore } from './use-history-store';

import { toRaw } from 'vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'mg-history-route-tabs',
  props: {
    showHome: {
      type: Boolean,
      default: true
    },
    // 是否显示首页
    homePath: {
      type: String,
      default: '/'
    },
    homeTitle: {
      type: String,
      default: '首页'
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    minLoading: {
      type: Number,
      default: 1000
    },
    items: {
      type: Array,
      default: () => []
    },
    tabProps: {
      type: Object,
      default: () => ({})
    },
    appGroup: {
      type: String,
      default: 'default'
    },
    bkColor: {
      type: String,
      default: '#e1e1e1'
    },
    tabActiveColor: {
      type: String,
      default: '#fff'
    },
    tabColor: {
      type: String,
      default: 'rgba(255,255,255, 0.3)'
    },
    storeKey: {
      type: String,
      default: 'icloud-visit-view-store',
      required: true
    }
  },
  emits: ['tab-changed', 'tab-close', 'update:activeTab', 'refresh-data-click', 'close-win-click', 'tab-menu-click'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const router = useRouter();
    const route = useRoute();
    const props = __props;
    const loadingOptions = reactive({
      loadRouteId: '',
      startTime: 0,
      loading: false,
      timer: 0 // 关闭loading的定时器
    });
    const startLoading = route => {
      Object.assign(loadingOptions, {
        startTime: new Date().getTime(),
        loadRouteId: historyStore.createRouteId(route),
        loading: true
      });
    };
    const stopLoading = () => {
      const endTime = new Date().getTime();
      if (endTime - props.minLoading < loadingOptions.startTime) {
        loadingOptions.timer = setTimeout(() => {
          loadingOptions.timer = 0;
          loadingOptions.loading = false;
        }, props.minLoading - (endTime - loadingOptions.startTime));
      } else {
        loadingOptions.loading = false;
      }
    };
    onUnmounted(() => {
      const t = loadingOptions.timer;
      if (t) {
        loadingOptions.timer = 0;
        clearTimeout(t);
      }
    });
    const useHistoryStore = createUseHistoryStore({
      storeKey: props.storeKey
    });
    const emit = __emit;
    const historyStore = useHistoryStore();
    const resetHistory = () => {
      historyStore.$reset();
    };
    const contextmenuPos = reactive({
      left: 0,
      top: 0
    });
    const showContextmenu = ref(false);
    const activeRoute = computed(() => {
      return historyStore.getCurrentRoute(props.appGroup);
    });
    const activeTab = ref('home-page');
    watch(() => activeRoute.value, val => {
      const {
        fullPath,
        id
      } = val || {};
      if (!fullPath || fullPath === '/' || fullPath === '/index' || fullPath === '/home') {
        activeTab.value = 'home-page';
        return;
      }
      activeTab.value = id || historyStore.createRouteId(toRaw(val));
    }, {
      deep: true
    });
    onMounted(() => {
      const oldRoute = historyStore.getCurrentRoute(props.appGroup);
      if (oldRoute) {
        if (route.path !== oldRoute.path) {
          router.push(route);
        }
      }
    });
    router.beforeEach((to, _, next) => {
      if (props.showLoading) {
        startLoading(to);
      }
      next();
    });
    router.afterEach(() => {
      if (loadingOptions.loading) {
        stopLoading();
      }
    });
    watch(() => route.fullPath, activePath => {
      if (!activePath || activePath === '/' || activePath === '/index' || activePath === '/home') {
        return;
      }
      historyStore.add(toRaw(route));
    }, {
      immediate: true
    });
    const {
      historyGroupRoutes
    } = storeToRefs(historyStore);
    const groupRoutes = ref([]);
    watch(() => historyGroupRoutes.value, val => {
      groupRoutes.value = (val || {})[props.appGroup] || [];
    }, {
      deep: true,
      immediate: true
    });
    const tabOptions = computed(() => {
      const tabs = groupRoutes.value || [];
      if (!tabs || !Array.isArray(tabs)) {
        return [];
      }
      return tabs.map(item => {
        const {
          id,
          ...more
        } = item;
        return {
          id: id || historyStore.createRouteId(item),
          ...more
        };
      });
    });
    const getTabOptionById = id => {
      return tabOptions.value.find(t => t.id === id);
    };
    const pushRouteByID = id => {
      const route = tabOptions.value.find(item => item.id === id);
      if (!route) return;
      const {
        path,
        query = {}
      } = route;
      router.push({
        path,
        query: query || {}
      }).catch(err => {
        console.debug('[historyRouteTabs]push route error:', err);
      });
      return route;
    };
    const closeRouteById = id => {
      const route = getTabOptionById(id);
      if (!route || !route.meta || !route.meta.closable) return; // 不允许关闭
      const {
        route: nextRoute
      } = historyStore.delete(route);
      if (!nextRoute) {
        if (props.showHome) {
          router.push({
            path: props.homePath
          });
          return {
            path: props.homePath,
            meta: {
              title: props.homeTitle
            }
          };
        }
        return;
      }
      const {
        path,
        query,
        params
      } = nextRoute;
      nextTick(() => {
        router.push({
          path,
          query: query || {},
          params: params || {}
        });
      });
      return nextRoute;
    };
    const doRefresh = () => {
      emit('refresh-data-click');
    };
    const refreshCurrentPage = () => {
      doRefresh(activeTab.value);
    };
    const defaultTabProps = {
      type: 'round-card',
      position: 'top',
      padding: true,
      showBody: false,
      trigger: 'click',
      appGroup: 'default',
      destroyOnClose: true,
      'beforeChangeMethod'() {
        return true;
      },
      closeConfig: {
        enabled: false
      }
    };
    const tabAttrs = computed(() => {
      return {
        ...defaultTabProps,
        ...props.tabProps
      };
    });
    const defaultTabMenus = [{
      title: '刷新页面',
      name: 'refresh'
    }, {
      title: '关闭其他页签',
      name: 'closeOther'
    }, {
      title: '当前当前页',
      name: 'closeCurrent'
    }, {
      title: '关闭所有页',
      name: 'closeAll'
    }];
    const handleRefreshCurrentPage = () => {
      refreshCurrentPage();
    };
    const tabMenuOptions = computed(() => {
      return [...defaultTabMenus, {
        title: '--'
      }, ...tabOptions.value.map(item => {
        const {
          id,
          name,
          path,
          query,
          meta,
          ...more
        } = item || {};
        if (!(path || name) && !meta?.title) return null;
        const isActive = activeTab.value === id;
        return {
          id,
          title: meta?.title || '',
          name,
          path,
          query,
          isActive,
          meta: {
            ...meta,
            title: meta?.title || ''
          },
          icon: isActive ? 'fa fa-check' : '',
          ...more
        };
      }).filter(t => !!t)];
    });
    const closeOtherPage = () => {
      historyStore.deleteOther(route);
    };
    const closeAllPage = () => {
      historyStore.clearGroup(props.appGroup);
      router.push({
        path: '/'
      }).then(() => {
        window.location.reload();
      });
    };
    const closeCurrentPage = () => {
      closeRouteById(activeTab.value);
    };
    const handleCloseTab = (route, $event) => {
      const {
        id = ''
      } = route || {};
      const nextRoute = closeRouteById(id);
      if (nextRoute) {
        emit('tab-close', {
          route,
          nextRoute,
          $event
        });
      }
    };
    const tabEventHandlers = {
      'tabClick'({
        name,
        $event
      }) {
        if (name === props.homePath || name === 'home-page') {
          // 处理首页
          return router.push({
            path: props.homePath
          });
        }
        const route = tabOptions.value.find(item => item.id === name);
        if (!route) return false;
        const {
          id
        } = route;
        nextTick(() => {
          const nextRoute = pushRouteByID(id);
          if (nextRoute) {
            emit('tab-changed', {
              route,
              nextRoute,
              $event
            });
          }
        });
      },
      'contextmenu'(e) {
        e.preventDefault();
        e.stopPropagation();
        Object.assign(contextmenuPos, {
          left: e.clientX,
          top: e.clientY
        });
        showContextmenu.value = true;
      }
    };
    const handleTabMenuClick = ({
      item,
      $event
    }) => {
      const {
        id,
        name
      } = item || {};
      switch (name) {
        case 'refresh':
          refreshCurrentPage();
          break;
        case 'closeAll':
          closeAllPage();
          emit('close-win-click', {
            action: name,
            $event
          });
          break;
        case 'closeCurrent':
          closeCurrentPage();
          emit('close-win-click', {
            action: name,
            $event
          });
          break;
        case 'closeOther':
          closeOtherPage();
          emit('close-win-click', {
            action: name,
            id,
            $event
          });
          break;
        default:
          emit('tabMenuClick', {
            ...item,
            $event
          });
          const route = pushRouteByID(id);
          if (route) {
            emit('tab-menu-click', {
              route,
              $event
            });
          }
      }
    };
    __expose({
      resetHistory,
      'closeCurrent'() {
        closeCurrentPage();
      },
      'closeOther'() {
        closeOtherPage();
      },
      'closeAll'() {
        closeAllPage();
      },
      'getHistoryRoutes'() {
        return tabOptions.value;
      },
      'setCurrentTabTitle'(title) {
        historyStore.setTitle(route, title);
      },
      'setTabTitle'(oRoute, title) {
        historyStore.setTitle(oRoute, title);
      }
    });
    const updateThemeStyle = ({
      bkColor,
      tabColor,
      tabActiveColor
    }) => {
      document.documentElement.style.setProperty('--visit-win-bar-bk-color', bkColor);
      document.documentElement.style.setProperty('--visit-win-bar-tab-color', tabColor);
      document.documentElement.style.setProperty('--visit-win-bar-tab-active-color', tabActiveColor);
    };
    watch(() => [props.bkColor, props.tabColor, props.tabActiveColor], newVal => {
      const [bkColor, tabColor, tabActiveColor] = newVal;
      updateThemeStyle({
        bkColor,
        tabColor,
        tabActiveColor
      });
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_tab_pane = _resolveComponent("vxe-tab-pane");
      const _component_vxe_tabs = _resolveComponent("vxe-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_tabs, _mergeProps({
        "model-value": activeTab.value
      }, tabAttrs.value, _toHandlers(tabEventHandlers)), {
        "tab-prefix": _withCtx(() => [_createVNode(_component_vxe_button, {
          mode: "text",
          icon: "vxe-icon-refresh",
          onClick: handleRefreshCurrentPage
        })]),
        "tab-suffix": _withCtx(() => [_createVNode(_unref(MgDropMenu), {
          items: tabMenuOptions.value,
          onItemClick: handleTabMenuClick,
          direction: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_button, {
            mode: "text",
            icon: "vxe-icon-ellipsis-v"
          })]),
          _: 1
        }, 8, ["items"])]),
        default: _withCtx(() => [_createVNode(_component_vxe_tab_pane, {
          title: __props.homeTitle,
          name: "home-page"
        }, null, 8, ["title"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabOptions.value, item => {
          return _openBlock(), _createBlock(_component_vxe_tab_pane, {
            key: item.name,
            title: item.meta?.title,
            name: item.id
          }, {
            "title-prefix": _withCtx(() => [__props.showLoading && loadingOptions.loading && item.id === loadingOptions.loadRouteId ? (_openBlock(), _createElementBlock("span", _hoisted_2)) : _createCommentVNode("", true)]),
            "title-suffix": _withCtx(() => [item.closable || item.meta?.closable ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 0,
              mode: "text",
              icon: "vxe-icon-close",
              onClick: _withModifiers(e => handleCloseTab(item, e), ["stop"])
            }, null, 8, ["onClick"])) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["title", "name"]);
        }), 128))]),
        _: 1
      }, 16, ["model-value"]), _createVNode(_unref(MgPopMenu), _mergeProps({
        items: tabMenuOptions.value,
        show: showContextmenu.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showContextmenu.value = $event)
      }, contextmenuPos, {
        onItemClick: handleTabMenuClick
      }), null, 16, ["items", "show"])]);
    };
  }
};